<template>
    <div class="sm:mb-4 p-6 text-white bg-gray-900 bg-primary-cta bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out mt-0 sm:rounded h-full">
        <tw-card height="bg-gray-800 sm:bg-gray-800 w-auto text-gray-900 relative text-white transition duration-500 ease-in-out mt-6">
            <racing-stars-icon class="rounded-full absolute -top-2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white p-2 bg-gray-800 text-white transition duration-500 ease-in-out" />

            <h2 class="text-white uppercase flex w-full justify-center mb-4 text-center px-4 py-4">{{ title }}</h2>

            <span class="flex w-full justify-center font-bold text-center text-5xl text-racing-stars-yellow"><counter ref="dailyJackpot" :startAmount="0" :endAmount="$page.props.racingstars.dailyJackpot / 100" :duration="duration($page.props.racingstars.dailyJackpot / 100)" prefix="&pound;" /></span>

            <span class="text-white uppercase text-1xl flex w-full justify-center text-center mb-4">Today</span>

            <span class="flex w-full justify-center font-bold text-center text-5xl text-racing-stars-yellow"><counter ref="weeklyJackpot" :startAmount="0" :endAmount="$page.props.racingstars.weeklyJackpot / 100" :duration="duration($page.props.racingstars.weeklyJackpot / 100)" prefix="&pound;" /></span>

            <span class="text-white uppercase text-1xl flex w-full justify-center text-center mb-4">This Week</span>

            <tw-button v-if="showAction && !$page.props.user.active_bet && $page.props.user.play_tokens" class="text-gray-800 bg-racing-stars-yellow w-full" @click="play()">Play Now</tw-button>

            <tw-button v-else-if="showBetButton && !$page.props.user.active_bet" class="text-gray-800 bg-racing-stars-yellow w-full" @click="placeBet()">Place Bet</tw-button>
        </tw-card>
    </div>
</template>
<script>
import { computed, ref } from 'vue'
import TwCard from '@/Global/Elements/TwCard'
import TwButton from '@/Global/Elements/TwButton'
import RacingStarsIcon from '@/Global/RacingStarsIcon'
import { getCurrentInstance } from 'vue'
import moment from 'moment'
import Counter from 'vue3-autocounter';
import { Inertia } from '@inertiajs/inertia'

export default {
    emits: ['bet'],

    props: {
        title: {
            type: String,
            default: 'Pick a Horse in Each Race for Potential Winnings of',
        },
        showAction: {
            type: Boolean,
            default: true,
        },
        showBetButton: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        TwButton,
        TwCard,
        RacingStarsIcon,
        Counter,
    },
    setup(props, { emit }) {

        const dailyJackpot = ref(null)

        const weeklyJackpot = ref(null)

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const play = () => {
            Inertia.get(route('play'))
        }

        const placeBet = () => {
            emit('bet')
        }

        const restartDaily = () => {
            if (dailyJackpot.value) {
                dailyJackpot.value.reset()
                dailyJackpot.value.start()
            }
        }

        const restartWeekly = () => {
            if (weeklyJackpot.value) {
                weeklyJackpot.value.reset()
                weeklyJackpot.value.start()
            }
        }

        const duration = (jackpot) => {
            return (parseInt(jackpot) / 100) * 6
        }

        return {
            formatter,
            play,
            dailyJackpot,
            weeklyJackpot,
            placeBet,
            restartDaily,
            restartWeekly,
            duration,
        }
    }
}

</script>
